module.exports = __webpack_public_path__ + "static/assets/82605c2ddff77109d8fafc0e4cf997ed.svg";